import * as actionTypes from "../actionTypes.js";

const initialState = {
  contactRequestsList: null,
  demoCertifyDomainsList: null,
  demoCertifyAnalytics: null,
  demoCertifyApprovals: null
};

const watchTowerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONTACT_REQUESTS_WT:
      return { ...state, contactRequestsList: action.payload };

    case actionTypes.GET_DEMO_CERTIFY_DOMAINS_WT:
      return { ...state, demoCertifyDomainsList: action.payload };

    case actionTypes.GET_DEMO_CERTIFY_ANALYTICS_WT:
      return { ...state, demoCertifyAnalytics: action.payload };

    case actionTypes.GET_DEMO_CERTIFY_APPROVALS_WT:
      return { ...state, demoCertifyApprovals: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default watchTowerReducer;